import GuestNestedLayout from '../guest-nested-layout/guest-nested-layout'
import MainLayout from '../main-layout/main-layout'

const GuestLayout = ({ children, nestedLayoutProps, ...props }) => {
	return (
		<MainLayout {...props}>
			<GuestNestedLayout {...nestedLayoutProps}>{children}</GuestNestedLayout>
		</MainLayout>
	)
}

export default GuestLayout
